  <template>
  <LoadingWrapper :state="status">
    <ul v-if="data.length" class="mb-16 flex flex-col gap-0.5">
      <li
        v-for="survey in data"
        :key="survey.templateId"
        class="[&>*]:rounded-md! first:[&>*]:rounded-t-xl! last:[&>*]:rounded-b-xl!"
      >
        <SurveyCard :survey="survey" />
      </li>
    </ul>
    <EmptyPage
      v-if="!data.length"
      :title="$t('survey.finished.empty')"
      :description="$t('survey.finished.emptyInfo')"
      icon="ballot"
    />
  </LoadingWrapper>
</template>
<script lang="ts" setup>
  import EmptyPage from '../../../core/components/empty-states/EmptyPage.vue'
  import LoadingWrapper from '../../../core/components/loading/LoadingWrapper.vue'
  import SurveyCard from '../../dashboard/components/SurveyCard.vue'
  import { useSurveys } from '../composables/useSurveys'
  import { SurveyState } from '../models/survey-state'

  const { data, status } = useSurveys({ states: [SurveyState.finished] })
</script>
